var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_859_17074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.5C9.5 10.0287 20.5 6 27 12.5V1.39028C24.762 0.495322 22.3211 0 19.7663 0C8.84895 0 0 8.95801 0 20.0099C0 27.1808 3.72807 33.468 9.32712 37H9.5V19.5Z",
    fill: "#42CBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 20.5C30.5 29.9713 19.5 34 13 27.5V38.6097C15.238 39.5047 17.6789 40 20.2337 40C31.1511 40 40 31.042 40 19.9901C40 12.8192 36.2719 6.53198 30.6729 3H30.5V20.5Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8356 16.1356C25.7737 16.461 25.6608 16.781 25.486 17.0822C24.6496 18.5317 22.7995 19.0265 21.35 18.1902C19.9005 17.3538 19.4057 15.5037 20.242 14.0542C20.4706 13.6589 20.7772 13.3362 21.1268 13.0914C20.761 13.0323 20.3846 13 20 13C16.1329 13 13 16.1329 13 20C13 23.8671 16.1356 27 20 27C23.8644 27 27 23.8671 27 20C27 18.572 26.5724 17.2436 25.8356 16.1356Z",
    fill: "#7964FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_859_17074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9401ef734f822df2d3304f7cf29c14d8.svg";
export { ForwardRef as ReactComponent };